import * as React from 'react';
import { generatePath, Navigate, Outlet, Route, Routes } from 'mini-react-router-dom';
import { getCommonRoutesForModule } from 'mini-common-routes';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { LazyA2HSTeachingPane } from 'mini-a2hs';
import { LazyMiniMailCampaignSurface } from 'mini-mail-module-campaign';
import { MailSearchPaneWrapper } from 'mini-mail-search-view';
import { MailSurface } from 'mini-mail-surface-view';
import { MiniWorkLoad } from 'mini-workload';
import { NPSFeedback } from 'mini-nps';
import { SearchModule } from 'mini-search-landing-view';
import { type SettingsSubRoutes } from 'mini-common-schema';
import { useHandleRouteChangeEvent } from '../hooks/useHandleRouteChangeEvent';
import {
    type MailRoutes,
    appendCatchAll,
    type SearchRoutes,
    type StorageSettingRoutes,
    type MiscRoutes,
    type SettingsRoutes,
} from 'mini-routes';
import {
    MailReadingPaneDeepLinkHandler,
    MailJsmvvmDeepLinkHandler,
    MailPushNotificationReadingPaneRouteHandler,
    MailPushNotificationComposeRouteHandler,
} from 'mini-mail-special-route-handlers';

export const MailModuleRoutes = () => {
    return (
        <Routes>
            <Route element={<MailModule />}>
                <Route index element={<Navigate to={'/inbox'} replace />} />
                <Route path={appendCatchAll('/:folderId')} element={<MailSurface />} />
                <Route path={'/teach'} element={<LazyA2HSTeachingPane />} />
                <Route
                    path={appendCatchAll('/search')}
                    element={
                        isMiniFeatureEnabled('mini-unified-search') ? (
                            <SearchModule />
                        ) : (
                            <MailSearchPaneWrapper />
                        )
                    }
                />
                <Route path={'/nps'} element={<NPSFeedback />} />
                {getCommonRoutesForModule(MiniWorkLoad.Mail)}
                {/* Special Routes Handling */}
                <Route
                    path={'/options/general/storage'}
                    element={
                        <Navigate
                            to={generatePath('/settings/:subRoute', {
                                subRoute: 'storage',
                            })}
                            replace
                        />
                    }
                />
                <Route
                    path={appendCatchAll('/jsmvvmdeeplink')}
                    element={<MailJsmvvmDeepLinkHandler />}
                />
                <Route
                    path={'/deeplink/read/:itemId'}
                    element={<MailReadingPaneDeepLinkHandler />}
                />
                <Route path={'/read/:itemId'} element={<MailReadingPaneDeepLinkHandler />} />
                <Route
                    path={'/:folderId/cId/:conversationId/iId/:itemId/immId/:immutableItemId'}
                    element={<MailPushNotificationReadingPaneRouteHandler />}
                />
                <Route
                    path={'/compose/reply/:itemId/:immutableItemId'}
                    element={<MailPushNotificationComposeRouteHandler />}
                />
            </Route>
        </Routes>
    );
};

const MailModule = () => {
    useHandleRouteChangeEvent();
    return (
        <>
            {/** Component which renders IRIS campaigns(tooltips, modals etc) */}
            <LazyMiniMailCampaignSurface />
            <Outlet />
        </>
    );
};
